const getters = {
  isLoggedIn: state => state.login.userInfo,
}
export default getters
